module.exports = __webpack_public_path__ + "img/95.ebece898.svg";